import LocationCitySearchResourcePagingResultModel from '../../generated/types/model/resource/LocationCitySearchResourcePagingResultModel';

export default class LocationCitySearchResourcePagingResultViewModel extends LocationCitySearchResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
